module.exports = "/_next/static/chromiums/apple-touch-192x192-icon-2778cd42cf2b92e8762a2181153ee1ed.png";